<script lang="ts">
	import { Button, Select, type SelectOptionPropsType } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { format } from 'src/services/i18n';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device, setting: string, options: string[];

	let value: string = '';
	let targetLock = false;
	let waitForResponse: boolean = false;

	const selectOptions: SelectOptionPropsType[] = (options || []).map((i) => {
		return {
			title: $format(`select_option_label_${i.toLowerCase().replace(/[\s-]/g, '_')}_desc`, {
				default: capFirstChar(i.replace(/[\s-_]/g, ' ')),
			}),
			value: i,
		};
	});

	const onSettingChange = (device: Device) => {
		const _value: string = getTemplateService(device)?.settings?.[setting];
		if (!waitForResponse && !targetLock && value !== _value) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	};

	const handleChange = (val: string) => {
		targetLock = true;
		value = val;
	};

	const saveOption = async () => {
		if (waitForResponse) return;
		waitForResponse = true;
		const res: SettingRequest = await gen2Request(device, 'Service.SetConfig', {
			id: 0,
			config: {
				[`${setting}`]: value,
			},
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: onSettingChange(device);
	onSettingChange(device);
</script>

<Select
	aria-label={$format('select_action', { default: 'Select Action' })}
	class="width-full mb-s"
	slot="main"
	value={selectOptions.find((i) => i.value == value) || selectOptions[0]}
	options={selectOptions}
	icon={null}
	on:change={(e) => {
		handleChange(e.detail['value']);
	}}
	id="select-tddstt1"
/>

<Button loading={waitForResponse} size="m" width="full" on:click={saveOption}
	>{$format('button_save')}</Button
>
